/**
 * Bridge imperativo: printerService (no-React) puede abrir el modal React
 * de configuración de impresora y esperar el resultado.
 */

let handler = null;

export function setPrinterConfigHandler(nextHandler) {
  handler = typeof nextHandler === 'function' ? nextHandler : null;
}

/**
 * @param {Object} options
 * @param {'configure'|'required'} [options.mode]
 * @param {string|number} [options.suggestedPrinterNumber]
 * @param {string|number} [options.idUbicacion]
 * @param {Array} [options.ubicaciones]
 * @returns {Promise<{ cancelled: boolean, printerNumber?: string }>}
 */
export function requestPrinterConfig(options = {}) {
  if (!handler) {
    return Promise.reject(new Error('Modal de impresora no disponible'));
  }
  return handler(options);
}
